<div class="metrics-card-collection">
  @if (metricCardCollection.title) {
    <div class="metrics-card-header" id="metric-card-title">
      {{ metricCardCollection.title }}
    </div>
  }
  @if (!metricCardCollection.statusMessage) {
    <div class="metrics-card-content">
      @for (metricCard of metricCardCollection.metricCards; track metricCard; let i = $index) {
        <emt-metric-card
          id="metric-card-{{ i }}"
          class="metric-card"
          [isCondensedMode]="isCondensedMode"
          [metricCard]="metricCard"
          [isLastChild]="i === this.metricCardCollection.metricCards.length - 1"
        ></emt-metric-card>
      }
    </div>
  }
  @if (metricCardCollection.statusMessage) {
    <div class="metrics-cars-status-message">
      {{ metricCardCollection.statusMessage }}
    </div>
  }
</div>
